const formatLocale = locale => ((locale || '').includes('-') ? locale.split('-')[0] : locale);

export default formatLocale;
